import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, slice } from 'lodash';

import { NB_AFFICHAGE_GRILLE } from '../../../services/directory/constants';

import ButtonComponent from '../../../components/button/ButtonComponent';
import { withLoadingCondition } from '../../loading/withLoadingCondition';
import PartnerBlockComponent from '../../../components/partner/PartnerBlockComponent';

class GridDirectoryComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            borneMax: NB_AFFICHAGE_GRILLE,
            scroll: 900
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    handleScroll() {
        if (window.scrollY > this.state.scroll) {
            this.setState({
                borneMax: this.state.borneMax + NB_AFFICHAGE_GRILLE,
                scroll: this.state.scroll + 900
            });
        }
    }

    onClickVoirPlus(e) {
        e.preventDefault();
        this.setState({
            borneMax: this.state.borneMax + NB_AFFICHAGE_GRILLE
        });
    }

    renderNoPartner = () => {
        const { partners, NO_PARTNER } = this.props;

        if (isEmpty(partners)) {
            return <div>{NO_PARTNER}</div>;
        }
    };

    renderSeeMoreButton = () => {
        const { partners, SEE_MORE_OFFERS } = this.props;

        if (partners && this.state.borneMax && partners.length > this.state.borneMax) {
            return (
                <div className="conteneur-voir-plus">
                    <ButtonComponent
                        color="second"
                        text={SEE_MORE_OFFERS}
                        cssClass="bt-plus-offres"
                        onClick={this.onClickVoirPlus.bind(this)}
                    />
                </div>
            );
        }
    };

    renderGrid = () => {
        const { partners, isCodePromo, isOffline, isEbon } = this.props;

        return (
            <div>
                <div id="annuaire-liste" className="grid-4-small-2 has-gutter">
                    {slice(partners, 0, this.state.borneMax).map(
                        (item, i) =>
                            item && (
                                <PartnerBlockComponent
                                    key={i}
                                    partner={item}
                                    isCodePromo={isCodePromo}
                                    isOffline={isOffline}
                                    isEbon={isEbon}
                                />
                            )
                    )}
                </div>
                {this.renderSeeMoreButton()}
            </div>
        );
    };

    renderPage = () => (
        <div>
            {this.renderGrid()}
            {this.renderNoPartner()}
        </div>
    );

    render() {
        return withLoadingCondition(this.props.fetching, this.renderPage);
    }
}

GridDirectoryComponent.propTypes = {
    isCodePromo: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    partners: PropTypes.array.isRequired,
    fetching: PropTypes.bool.isRequired
};

const mapStatetoProps = state => ({
    SEE_MORE_OFFERS: state.i18n.common.SEE_MORE_OFFERS,
    NO_PARTNER: state.i18n.page.DIRECTORY.NO_PARTNER
});

export default connect(mapStatetoProps)(GridDirectoryComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/GridDirectoryComponent.js